import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryChip = ({ category, selected, onClick }) => {
  const categoryIcons = {
    lifestyle: 'Home',
    fashion: 'Shirt',
    tech: 'Smartphone',
    food: 'UtensilsCrossed',
    travel: 'Plane',
    fitness: 'Dumbbell',
    beauty: 'Sparkles'
  };

  return (
    <button
      type="button"
      onClick={() => onClick(category?.value)}
      className={`flex items-center gap-2 px-4 md:px-5 lg:px-6 py-3 md:py-3.5 lg:py-4 rounded-xl transition-all duration-300 ${
        selected
          ? 'bg-gradient-to-br from-[var(--color-primary)] to-[var(--color-secondary)] text-white shadow-lg scale-105'
          : 'bg-[var(--color-card)] text-[var(--color-foreground)] hover:bg-[var(--color-muted)] border border-[var(--color-border)]'
      }`}
    >
      <Icon
        name={categoryIcons?.[category?.value]}
        size={18}
        color={selected ? '#FFFFFF' : 'var(--color-foreground)'}
      />
      <span className="text-sm md:text-base font-medium">{category?.label}</span>
    </button>
  );
};

export default CategoryChip;